import React from 'react';
import './AdPage.css';

const AdPage2 = () => {
  return (
    <div className="ad-page-container">
      <h1>Page 2</h1>
      <p>This is the second page with an ad banner.</p>
      
      <div className="ad-banner">
        <iframe 
          border="0" 
          src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
          style={{width:'300px', height:'250px'}} 
          frameBorder="0" 
          scrolling="no" 
          title="Trip.com Banner Advertisement"
        ></iframe>
      </div>
      
      <p>Additional content for Page 2 would go here.</p>
    </div>
  );
};

export default AdPage2;